import React from 'react';
import Box from '@mui/material/Box';
import { TableCard } from '../layout/TableCard';
import { CHART_PALETTE } from '../../theme/tokens';

// Re-exported for backward compatibility with existing imports.
export const CHART_COLORS = CHART_PALETTE;
export const ERROR_RED = '#DC2626';

export const ChartCard: React.FC<{
  title: string;
  subtitle?: string;
  height?: number;
  actions?: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, subtitle, height = 280, actions, children }) => {
  return (
    <TableCard title={title} subtitle={subtitle} actions={actions}>
      <Box sx={{ width: '100%', height }}>{children}</Box>
    </TableCard>
  );
};
